import { ActionProcessMode, ExecutedActionP } from '@infotech-soe/metaschema';

import { TActionArgsValues } from '../../../infrastructure/providers/abstract/IApiProvider';
import CachedSchemaRepository from '../../../infrastructure/schemas/storage/CachedSchemaRepository';
import { ClientContext } from '../../context/IContextService';
import { RefreshStrategy } from '../wrap/CategoryCommand';

import RunActionCommandImpl from './RunActionCommandImpl';

class CreateRecordCommandImpl extends RunActionCommandImpl {
  public async getInitialArgs(
    context: ClientContext
  ): Promise<TActionArgsValues> {
    const schemaRepository = new CachedSchemaRepository();
    const actionSchema = (await schemaRepository.getAction(
      context.get('Category'),
      this.action
    )) as ExecutedActionP;
    const actionArgs: TActionArgsValues = actionSchema.Args;

    if (!context.has('DisplayMode')) {
      return actionArgs;
    }

    let displayModeSchema;
    try {
      displayModeSchema = await schemaRepository.getDisplayMode(
        context.get('MasterCategory') || context.get('Category'),
        context.get('DisplayMode')
      );
    } catch {
      return actionArgs;
    }

    const result: TActionArgsValues = {};

    if (displayModeSchema.actionArgs) {
      const dsActionArgs = displayModeSchema.actionArgs;

      for (const args of Object.values(dsActionArgs)) {
        const controlNames = Object.keys(args);
        for (const arg of Object.keys(actionArgs)) {
          if (controlNames.includes(arg)) {
            const dsArg = args[arg];
            if (dsArg.kind === 'value') {
              result[arg] = dsArg.value;
            } else if (
              this.categoryVM.source.inParams &&
              this.categoryVM.source.inParams[dsArg.value]
            ) {
              result[arg] = this.categoryVM.source.inParams[dsArg.value];
            }
          }
        }
      }
    }

    return result;
  }

  public getProcessMode(): ActionProcessMode {
    return 'Any';
  }

  public getRefreshStrategy(): RefreshStrategy {
    return RefreshStrategy.NEW;
  }
}

export default CreateRecordCommandImpl;
